export const playlist = {
  'Public playlist': 'Lista de reproducción',
  songs: 'canciones',
  Name: 'Nombre',
  Skills: 'Habilidades',
  Filter: 'Filtrar',
};
